// src/services/stats.ts
import { apiGet } from "./baseFetch";

export type KPIs = {
  active_deals: number;
  total_deals: number;
  total_raised: number;
  avg_raise: number;
};


export type Commitments = {
  months: any[];
  series: any[]; // match what LineChart expects
};

export type PlatformStat = {
  platform: string;
  total_raised: number;
};

export type MomentumStat = {
  momentum: string;
  count: number;
};

type StatsOptions = {
  delay?: number;
  signal?: AbortSignal;
};

export async function fetchKpis(
  options: StatsOptions = {}
): Promise<KPIs> {
  const { delay = 0, signal } = options;
  const data = await apiGet<KPIs>("/stats/kpis", { signal });
  if (delay) {
    await new Promise((r) => setTimeout(r, delay));
  }
  return data;
}

export async function fetchCommitments(
  options: StatsOptions = {}
): Promise<Commitments> {
  const { delay = 0, signal } = options;
  const data = await apiGet<Commitments>("/stats/commitments", { signal });
  if (delay) {
    await new Promise((r) => setTimeout(r, delay));
  }
  return data;
}

export async function fetchPlatformStats(
  options: StatsOptions = {}
): Promise<PlatformStat[]> {
  const { delay = 0, signal } = options;
  const data = await apiGet<PlatformStat[]>(
    "/stats/platform-breakdown",
    { signal }
  );
  if (delay) {
    await new Promise((r) => setTimeout(r, delay));
  }
  return data;
}

export async function fetchMomentumStats(
  options: StatsOptions = {}
): Promise<MomentumStat[]> {
  const { delay = 0, signal } = options;
  const data = await apiGet<MomentumStat[]>("/stats/momentum-mix", {
    signal,
  });
  if (delay) {
    await new Promise((r) => setTimeout(r, delay));
  }
  return data;
}
